const solutionData = {
  indoor: [
    //1
    {
      id: "singlechain",
      name: "Wand Controlled Motor for Cordless Solution",
      desc: "Handle external intelligent DC tubular motors AM25 DC motor is ",
      description: "Handle external intelligent DC tubular motors  AM25 DC motor is consist of DC motor, reducer, PCB board, shock absorbers and handle controller. It has the characteristics of small volume, light weight, low noise, accurate limit position, strong concealment, convenient installation and so on. Especially the low power consumption design makes the motor runing longer than expects.",
      img : "/indoor/i1.jpg",
      imgs : "/indoor/i1/20220725112815_58641.JPG", 
      text :[
        ""
      ],
      features: [
        "Rechargeable by lithium battery, battery pole or solar panel;",
        "Helical gear design with patent, noise level is 35dB",
        "Auto correct shifting during braking",
        "Customized operation stick with PVC sheathed sleeve",
        "Wand control makes your system more humanized",
        "Obstacle detectable for protection",
        "Patented power saving design will make your system to be environmental protection and energy saving"
      ],
        Application: [
        { 
        text : "External battery pole supplying power to motor, suit for the applications which are without reserved power supply, effffective solutions to solve the power supply troubles.",
        img :"/indoor/i1/20220725112227_18905.JPG",
        },
        { 
        text : "External battery pole supplying power to motor, suit for the applications which are without reserved power supply, effffective solutions to solve the power supply troubles.",
        img :"/indoor/i1/20220725112244_57255.JPG",
        },
          { 
        text : "External battery pole supplying power to motor, suit for the applications which are without reserved power supply, effffective solutions to solve the power supply troubles.",
        img :"/indoor/i1/20220725112305_35751.JPG",
        },
  ],
      para: [
        {
          model: "AM56-L400N-400mm",
          voltage: "AC100-240V",
          force: "400N",
          speed: "10mm/s",
          frequency: "868.3MHz",
          width: "0.65–1.5m",
          power: "28W",
          temp: "-20℃~+85℃",
          size: "572×42×45 mm",
          ip: "IP32",
        },
      ],
    },
    // 2
   {
  id: "motorizedroof",
  name: "Motorized Roof Curtain Solution",
  desc: "The system uses a-OK tubular motor, using A spring and A tubular motor ",
  description: "",
  img: "/indoor/i2.jpg",

  texts : [
 "The system uses a-OK tubular motor, using A spring and A tubular motor; One end of the fabric is attached to a spring-loaded coil. The coil of steel rope at the other end of the fixed fabric is mounted on another reel equipped with a tubular motor coil. The motor provides power and the spring provides rewinding elasticity, thus keeping the tension in operation or at rest. After the curtain is completely opened, the fabric will be rolled on the spring coil tube, and the system selects the curtain fabric with certain tensile strength. According to the use of different occasions, can choose switch control, infrared remote control, radio remote control and intelligent control. Control mode can be controlled individually and group control. Indoor roof curtain is assembled by motor and transmission device, supporting components and curtain fabric. And theAngle between the curtain and the horizontal plane is less than 75, used for transparent roof in the horizontal, inclined and curved state of the building shading device. Roof shade includes scroll type canopy shade, folding canopy shade, 100 fold type canopy shade, shutter type canopy shade. Scroll type canopy curtain, divides into FTS canopy curtain and FSS canopy curtain. Product functions: sunshade, anti-glare, prevent indoor greenhouse effect, reduce energy consumption.",

  ],
  imgs: [    
  ],

  features: [
    "Stable transmission system with spring and motor.",
    "Can be controlled via switch, intelligent controller, IR remote or radio remote.",
    "Transparent or inclined fabric application for buildings.",
    "Supports scroll type canopy shade, folding canopy shade, roller type canopy curtain, and PSS canopy curtain."
  ],
  Application: [
    {
      text: "Product functions: sunshade, anti-glare, prevent indoor greenhouse effect, reduce energy consumption.",
      img:"/indoor/i2/1.jpg",

    },
    {
      text: "Application areas: glass roof, pergolas, etc.",
      img: "/indoor/i2/2.jpg"
    },
     {
    
      img: "/indoor/i2/3.jpg"
    }
  ],
  parameters: [
    {
      model: "AM45 series",
      productType: "AM45 tubular motor",
      length: "602mm",
      torque: "30/17 40/17 50/17 60/17",
      protection: "IP44",
      desc: "Mechanical limit, max limit circle 55."
    },
    {
      model: "AM45 series",
      productType: "AM45 network motor",
      length: "602mm",
      torque: "30/17 40/17 50/17 60/17",
      protection: "IP44",
      desc: "Mechanical limit, network built-in."
    },
    {
      model: "AM56 series",
      productType: "AM56 network motor",
      length: "682mm",
      torque: "30/17 40/17 50/17 60/17",
      protection: "IP44",
      desc: "Mechanical limit, network built-in, RS485/RS485."
    },
    {
      model: "AM56 panel track",
      productType: "AM56 panel/track motor",
      length: "682mm",
      torque: "30/17 40/17 50/17 60/17",
      protection: "IP44",
      desc: "Mechanical limit, customized solutions."
    }
  ]
},

  //3
    {
        id: "verticalcurtain",
        name: "Motorized Vertical Curtain Solution",
        desc: "Motorized vertical curtain adopts the structure of swing page, the page ",
        description: "",
        img: "/indoor/i3.jpg",
         texts : [
          "Motorized vertical curtain adopts the structure of swing page, the page can be 170° rotation, through the motor mechanical transmission mode to achieve the curtain dimming and retraction, not only can adjust the indoor light freely, but also ventilation, and can achieve the purpose of shading. Motorized vertical curtain sets practical sense of the Times and artistic feeling in one, It is popular in the office buildings, government agencies and public places because of its warm, elegant and generous.",
         ],

       
        features: [
          "Dc motor, low noise, high efficiency, long life;",
          "Built-in switching power supply, suitable for wide voltage range;",
          "Sensitive overload protection function, when the track is blocked, curtain stuck or curtain pulled, the operation automatically stop",
          "Aluminum alloy curtain, high strength, better weather resistance;",
          " Independent curtain hanging system, can be in the range of 170° arbitrary limit curtain turning Angle, while maintaining ventilation at the same time arbitrary control of light intensity.",
      
        ],
        Application: [
          {
            text: "System solution",
            img: "/indoor/i3/1.jpg"
          },
          {
            text: "Motorized vertical curtain solution and structure",
            img: "/indoor/i3/2.jpg"
          }
        ],
        para: [
          {
            model: "AM50-2",
            torque: "2 Nm",
            frequency: "433.92 Hz",
            speed: "4560 rpm",
            maxLoad: "15 kg",
            maxWidth: "6 m",
            limit: "6 turns",
            voltage: "220–240V",
            temp: "-20℃ ~ +60℃"
          }
        ]
      },
      //4
      {
        id: "MotorizedSheer",
        name: "Motorized Sheer",
        desc: "Motorized Sheer is an extension of the motorized roller blinds product",
        // description: "Motorized Sheer is an extension of the motorized roller blinds product, used in hotels, high-grade residential bedrooms, office French Windows and other occasions. The fabric of Motorized Sheer is divided into two kinds of light transmission and shading. The material is 100% polyester fiber cloth, the table and the back double layer gauze structure, and the intermediate layer polyester fiber curtain can be opened or closed to provide semi-transparent effect. The curtain fabric is usually treated with special anti-static, dust proof, anti-fouling and anti-mildew, which can effectively resist dust, moisture, splash or fingerprint in the air, and has excellent dirty resistance. A-ok motor has adjustable middle limit, which can be placed in the state of curtain body down. When the curtain body is in the vertical shading state, press the 'switch' button, no matter where the soft curtain is, it will automatically reach the shading state.",
        img: "/indoor/i4.jpg",
      
      
        texts :[
         "Motorized Sheer is an extension of the motorized roller blinds product, used in hotels, high-grade residential bedrooms, office French Windows and other occasions. The fabric of Motorized Sheer is divided into two kinds of light transmission and shading. The material is 100% polyester fiber cloth, the table and the back double layer gauze structure, and the intermediate layer polyester fiber curtain can be opened or closed to provide semi-transparent effect. The curtain fabric is usually treated with special anti-static, dust proof, anti-fouling and anti-mildew, which can effectively resist dust, moisture, splash or fingerprint in the air, and has excellent dirty resistance.",
         "A-ok motor has adjustable middle limit, which can be placed in the state of curtain body down. When the curtain body is in the vertical shading state, press the 'switch' button, no matter where the soft curtain is, it will automatically reach the shading state.",
        ],
        Application: [
          {
            text: "",
            img: "/indoor/i4/1.jpg"
          },
          
        ],
        
        
      },

      //5

       {
        id: "MotorizedHoneycomb",
        name: "Motorized Honeycomb Blinds Solution",
        desc: "Honeycomb shade is also called organ shade , its inspiration from  ",
        // description: "Honeycomb shade is also called organ shade , its inspiration from the most perfect architecture “honeycomb design”, the product has outstanding performance in dimming, shading, heat preservation, convenient use. In the middle of fixed cellular static air layer is very thick, completely cut off from the window on both sides of the heat conduction, heat preservation and heat insulation .It has the incomparable function .Different fabric on both sides and the light is filtered and diffused twice ,makes the room more comfortable .With special waterproof treatment of different fabrics, you can easily obtain the dimming requirements of all gradients from flexible yarn level to full shading, is an expert in room light control, suitable for use in the room, living room, kitchen, toilet and other environmental conditions.",
        img: "/indoor/i5.jpg",
        imgs: "/indoor/",
        texts:[
          "Honeycomb shade is also called organ shade , its inspiration from the most perfect architecture “honeycomb design”, the product has outstanding performance in dimming, shading, heat preservation, convenient use. In the middle of fixed cellular static air layer is very thick, completely cut off from the window on both sides of the heat conduction, heat preservation and heat insulation .It has the incomparable function .Different fabric on both sides and the light is filtered and diffused twice ,makes the room more comfortable .With special waterproof treatment of different fabrics, you can easily obtain the dimming requirements of all gradients from flexible yarn level to full shading, is an expert in room light control, suitable for use in the room, living room, kitchen, toilet and other environmental conditions.",
        ],
       
        Application: [
          {
            text: [
              "Heat insulation and heat preservation, air static solid layer formed by holes in honeycomb fabric brings extraordinary heat insulation and heat preservation effect",
              "Noise isolation, honeycomb hole can play a good noise isolation effect, create a quiet and comfortable home environment",
             "Block uv rays, blocking up to 99% uv rays, effectively protect furniture",
              "Variety of styles, honeycomb curtain fabrics are transparent, semi-transparent, light isolation and other styles: in color, texture and printing rich choice",
              "Easy to maintain, the fabric is antifouling and antistatic treatment, usually only need to use a portable vacuum cleaner or wet cloth after wiping.",

            ],
          
          },
          {
            text: "System structure",
            img: "/indoor/i5/1.jpg"
          },
        ],
        features: [
          "Honeycomb shape can contain air, can prevent heat increase in summer and heat loss in winter, the curtain has the effect of sound-absorbing heat insulation",
          " Can be made of polyester non-woven fabric, warp knitted fabric, knitted fabric, woven fabric and other materials to meet more personalized needs;",
          "Fabric with special processing, can be flame retardant, anti-static, anti-ultraviolet, waterproof, anti-oil,antibacterial and other environmental protection functions;",
          "The rope hide design and neat skirt print make the honeycomb curtain looks more simple ,delicate and grace;",
          "Various of the installation structure, optional conventional open type, up and down with open type, up and down combination of day and night curtain type.",

        ],
      },

      //6
       {
        id: "MotorizedHollow",
        name: "Motorized Hollow Aluminum Venetian Solution",
        desc: "Indoor hollow aluminum venetian is a new energy-saving product which ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i6.jpg",
         texts : [
          "Indoor hollow aluminum venetian is a new energy-saving product which installs louver inside hollow glass. It combines the traditional venetian with hollow glass, which saves the use space and inconvenience, and realizes the comprehensive performance of hollow glass heat preservation and shutter shading. venetian insulating glass has the function of blinds lifting and turning Angle of 180 degrees, has good sunshade performance, improves insulating performance of insulating glass, improves indoor light environment, and is widely used in energy-saving building doors and Windows."
       ],

       
        features: [
          "Sound insulation: the unique structure of hollow aluminum venetian makes its sound insulation performance up to 32dB;",
          "Shading: when the blinds are put into insulating glass, the Angle of the slats can be adjusted at will to achieve natural lighting and complete shading",
          "Environmental protection: hollow aluminum venetian do not produce any pollution in the process of production and use, either blindss or glass. And because the blinds is in the insulating glass with sealing treatment, the permanent seal ensures that the slats are permanently clean and free from pollution, avoiding complex cleaning work;",
          "Energy saving: Because the K value (heat transfer coefficient) of insulating glass is lower than that of single-layer glass, the K value of ordinary insulating glass is 2.8W /m2.k, and that of single-layer glass is 6.0W /m2, the optimal K value of louver insulating glass is 1.8W /m2.k, and in summer, hollow aluminum venetian blinds can block sunlight and reduce indoor temperature; In winter, adjust the blinds Angle lighting and heating, can improve the indoor temperature, so no matter the use of air conditioning or heating, the use of hollow aluminum venetian blinds can make energy consumption significantly reduced",
          "Safety: because of the double-layer toughened glass structure, high wind resistance and external impact force, hollow glass is the most suitable for high-rise or coastal buildings. In addition, because the Venetian insulating glass has replaced the traditional curtain, the fire hazard is greatly reduced."
      
        ],
        Application: [
          {
            text: "Aluminum venetian blinds structure",
            img: "/indoor/i6/1.jpg"
          },
          
  
        ],
      
      },
   // 7 
      
        {
        id: "MotorizedWood",
        name: "Motorized Wood Venetian Solution",
        desc: "Indoor motorized wood venetian is widely used in office building, hotel,",
        description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i7.jpg",
         texts : [
          "Indoor motorized wood venetian is widely used in office building, hotel, study, meeting room partition, bathroom or league wash room partition and other places.",
          " Indoor motorized wood venetian color is the main selection basis; Lighting adjustment and interior decoration beautification are its main functional appeals; Mainly used in hotel rooms and residential bedrooms; The main width of the curtain is 50mm and 35mm."
        ],

       
        features: [
          "Hidden: when the blade is adjusted to 15 degrees to 25 degrees, the outside can not see the interior, there are excellent hidden effects, and there are ventilation Windows for indoor air convection circulation",
          "Daylighting: adjustable blades with 0 to 105 degrees of shading can control indoor daylighting and shading at wil",
          "Ventilation: when the blade is adjusted to 90 degrees, the maximum visual field and ventilation volume can be reached",
          "Rain proof: can effectively resist the invasion of wind and rain;",
          "Heat preservation, heat insulation and noise reduction: when the blades are closed, the sash is airtight, and the double-layer hollow design of the louver blade tail can effectively maintain the indoor temperature and isolate the outdoor high temperature, and reduce the noise by more than 30 decibels;",
          "Fire control: it can be combined with the fire control center as an automatic smoke exhaust and heat dissipation outlet."
        ],
        Application: [
          {
            text: "System solutions",
            img: "/indoor/i7/1.jpg"
          },
            {
            text: "Motorized wood venetian blinds solution and structure",
            img: "/indoor/i7/2.jpg"
          },
  
        ],
      
      },

      // 8
         {
        id: "MotorizedAluminum",
        name: "Motorized Aluminum Venetian Blinds Solution",
        desc: "Indoor motorized wood venetian is widely used in office building, hotel,",
        description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i8.jpg",
         texts : [
          " Indoor motorized aluminum venetian uses aluminum alloy curtain, through the coil system to drive the curtain body up and down operation and curtain piece turn over, play the role of light regulation and guidance, sun shading and heat insulation and decoration and beautification. Indoor blinds are installed in indoor or double-glazed rooms, with long service life, easy to clean and maintain (no wind influence), easy to install, low cost (relative to outdoor blinds), and no impact on the building structure; Dynamic use with optimized combination of high reflection glass or double breathing curtain wall glass.",
          " Indoor motorized blinds are widely used in office buildings, hotels, study, conference room partition, bathroom or league wash room partition and other places. Indoor blinds can be used alone or combined with other window decoration products. Aluminum alloy shutter: color, aperture size and thermal radiation effect of fabric coating as the main selection basis; Light regulation and sun shading and heat insulation as the main function appeals; Mainly used in business office buildings, conference rooms, etc. The waterproof properties of the curtain are used more and more in the hotel room partition: the width of the curtain is mainly 25mm and 35mm, the maximum is not more than 50mm."
        ],

       
        features: [
          "Can set up, middle, lower three limit points, power off stroke memory function;",
          " Supports two operating modes: click operation and continuous operation. The default mode is continuous operation",
          " It is convenient to change the motor running direction;",
          "Direct detection of motor rotation number, high positioning accuracy",
          "Position sensor open and short circuit protection function, blocking protection stop function",
          "Built-in superheterodyne receiving module, receiving sensitivity≥110dbm, remote control distance >80m.",
          "Constant speed function, multiple synchronous speed consistent, rated speed 34rpm, error < 1rpm soil;",
          "Automatic travel setting function and fabric release function to prevent the impact of extrusion on the system;",
          "Fast start, fast response speed, slow down and stop near the stroke, to prevent the impact on the system."
        ],
        Application: [
          {
            text: "System solutions",
            img: "/indoor/i8/1.jpg"
          },
            {
            text: "Motorized aluminum venetian blinds solution and structure",
            img: "/indoor/i8/2.jpg"
          },
  
        ],
      
      },

      //9 
          {
        id: "RollerBlinds",
        name: "Roller Blinds Solution",
        desc: "Motorized roller blind is a kind of driving by the AC-DC tubuar motor",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i9.jpg",
         texts : [
          "Motorized roller blind is a kind of driving by the AC or DC tubuar motor with the intelligent remote control system. It can be up and down with the power switch, simple operation ,quiet and stable work ,is the upgrade of manual rolling blinds products.",
          "The motor is directly installed in the aluminum alloy coil tube which not only reduces the volume of the curtain box and the transmission link of the force ,but also avoids the external influence on the motor and the increases the reliability of the mechanism.",
          "The coil is made of high quality aluminum alloy material with high strength and not easy to deform .The surface is anodized to prevent aging and corrosion .The mounting bracket is made of high-strength alloy steel with high bending and shearing strength to ensure the safety and reliability of the installation of the mechanism.",
          "Motorized roller blind is installed in indoor or double glass room to avoid adverse effects from the outside and improve the service life of system . It can block the sunshine in summer and reduce the load of air conditioning and adjust the visual comfort in winter . If use the radio remote control or intelligent building control ,can achieve a variety of intelligent control methods to meet the high quality requirements of users.",
          "The motorized roller blind can be used in the form of 'one drag more', adding a balance or universal joint in the mechanism ,then the motor can drag multiple pairs of fabrics at the same time.",
          "When the motor is running, several pieces of fabric move up and down together to achieve better shading and sunshade effect.The advantages of reducing the failure rate of institutions and reducing engineering costs are also very prominent. In the modern intelligent building, the control system of the electric coil can also be connected with the control center of the building, which is convenient to achieve long-distance large-scale centralized control.",
          ],

       
        features: [
          "AC/DC tubular motor are optional to be the automation devices;",
          "To meet the overall shading requirements, special shading slots can be installed on both sides of the rolling curtain;",
          " Low noise of motor, simple and convenient adjustment of stroke, accurate and reliable stroke control;",
          "When the curtain is high or tilted, the guide rail or traction wire rope is used, the curtain can be up to 20m;",
          "Select motor types and models according to load weight, lifting height, cost and other factors;",
          "With the support bracket can achieve a motor to drive multiple curtains;",
          "According to the height of the curtain, you can choose the diameter of 55mm. 63mm, 70mm and other special aluminum tube for the curtain;",
          "According to the environmental requirements, you can choose shading, semi-shading and other types of curtain fabric."

        ],
        Application: [
          {
            text: "System solutions",
            img: "/indoor/i9/1.jpg"
          },
            {
            text: "Roller Blinds Solution",
            img: "/indoor/i9/2.jpg"
          },
  
        ],
      
      },

      // 10
          {
        id: "Motorized 25mm venetian blinds",
        name: "Motorized 25mm venetian blinds",
        desc: "25mm motorized venetian blinds mainly applied for middle and small",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i10.jpg",
         texts : [
          "25mm motorized venetian blinds mainly applied for middle and small size window, used for office, meeting room, villa, balcony, reading room hotel etc. with widely selection of aluminum slats, wood slats or bamboo slats, make a room feeling warmly, nature and enjoyable.",
        ],

        Application: [
          {
            text: "25mm venetian blinds structure and solution",
            img: "/indoor/i10/1.jpg"
          },
          {
            text: "Recommend Motor",
            img: "/indoor/i10/2.jpg"
          },
          {
            text: " AM16 Structure and solution",
            img: "/indoor/i10/3.jpg"
          },
          {
            text: "System Structure",
            img: "/indoor/i10/4.jpg"
          },
          {
            text: "Recommend Motor",
            img: "/indoor/i10/5.jpg"
          },
        ],
      
      },

      // 11

          {
        id: "Motorized50mm",
        name: "Motorized 50mm Venetian Blinds Solution",
        desc: "Horizontal venetian blinds,according the material,divided to the aluminum",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i11.jpg",
        imgs : "/indoor/i11/0.jpg",
        texts : [
          "Horizontal venetian blinds, according to the material, divided to the aluminum venetian, wood venetian, bamboo venetian, etc. installed inside the room or between two glasses. Warmly. nature and inviting, a classic combination that can make a room feel instantly more comfortable as well as more functional. lt is widely applied to the office window, house bedroom, villas etc. with advantage to keep privacy from outside, but indoor has good viewing of outside. Motorized wood blinds can be the best of both worlds - the natural warm of venetian blinds with the convenience of motorized operation. With motorized wood blinds, the remote control changes the tilt of the blinds to change the level of light allowed in. Remote controls can operate a single wood blind or a group all at once."
        ],

       
        features: [
          "Choices of aluminum slats, wood slats with various colors;",
          "Freely adjust slats to better control indoor light;",
          "Operated by A-OK remote controls for smart operation;",
          "Easy to install and operate, with reliable performance;",
          "Option of AC or DC motor according to the window electricity layout."
        ],
        Application: [
          {
            img: "/indoor/i11/1.jpg",
            text: "50mm venetian blinds structure and solution",
          },
          {
            text: "Thermal Insulation and Nature Light",
            img: "/indoor/i11/2.jpg"
          },
          {
            text: "Recommend Motor",
            img: "/indoor/i11/3.jpg"
          },
        
        ],
      
      },

      // 12

      
        {
        id: "MotorizedHoneycombb",
        name: "Motorized Honeycomb Blinds Solution",
        desc: "Cellular blinds, also called honeycomb blinds, its inspiration ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i12.jpg",
        imgs : "/indoor/i12/1.jpg",
       
        texts:[
          "Cellular blinds, also called honeycomb blinds, its inspiration from the most perfect architecture 'honeycomb design', feature a honeycomb design which provides insulation, creating a more comfortable room climate and increases energy efficiency. And the anti-uv and thermal insulation material effectively prevent home appliance aging from sunlight. Motorized honeycomb blinds provide the latest technology in window treatments for maximum convenience and comfort. The motors in motorized honeycomb shades are operated by remote controls, switches, timers and sensors. These options allow you to control your shade quickly and with ease, making motorized honeycomb a perfect solution for large or out-of-reach windows.",
        ],

       
        features : [
          "Honeycomb design with outstanding performance for insulation and sound absorption;",
          "Privacy and easy to control natural light;",
          "Adopt small size DC motor with lower noise;",
          "Low-power design, able to powered by battery or solar;",
          "Operated by A-OK remote controls for smart operation."
          ],
        Application: [
         
          {
            text: "",
            img: "/indoor/i12/2.jpg"
          },
          {
            text: "Recommend Motor",
            img: "/indoor/i12/3.jpg"
          },
        
        ],
      
      },

      // 13
         {
        id: "MotorizedShangri",
        name: "Motorized Shangri-La or Motorized Zebra Blinds Solution",
        desc: "Motorized Shangri-La Blinds, unique textures of fabric, good light transmit ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i13.jpg",
        imgs : "/indoor/i13/1.png",
        // imgs : "/indoor/i13/3.jpg",

       
        texts:[
          "Motorized Shangri-La Blinds, unique textures of fabric, good light transmitting and not color faded. In the middle, the polyester fiber cloth connected with surface and back soft fabrics, those two kinds of fabrics contribute to translucent and sun-shading. lt is popular applied for villa, hotels, office window etc. lt is the best choice for privacy and light control application."
        ],

       
        // features : [
        //    "Two kinds of fabrics contribute to translucent and sun shading;",
        //   "Turn the inner polyester fiber to adjust indoor ray Can be fully hide into the cassette box;",
        //   "Unique textures fabric, good light transmitting and not color faded;",
        //   "Close fabric and silk fabric woven interval;",
        //   "Free to change the indoor light as you like;",
        //   "Can be fully hide into the cassette box.",
        //   ],
        Application: [
         
          {
            text: "",
            img: "/indoor/i13/2.jpg"
          },
        
        
        ],
      
      },


      // 14
         {
        id: "MotorizedRoman",
        name: "Motorized Roman Blinds Solution",
        desc: "Motorized Roman Blinds or pleated blinds, fabric simple folded, ventilate",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i14.jpg",
      
        imgs : "/indoor/i14/1.jpg",
        // imgs : "/indoor/i14/2.jpg",
       
        texts:[
          "Motorized Roman Blinds or pleated blinds, fabric simple folded, ventilate and cool, very suitable to be used for residential house. The motorized roman blinds simplify the traditional complicated manual system, operated by remote control system, more convenient and simpler installation.",
        ],

       
        features : [
         " Driving:",
          "Drive by AM35, AM45 tubular motor, use the various size roller tubes and fabrics according to the window height to achieve perfect sun protection.",
          "Wave type and pleated type roman blinds.",
          "Various smart controls."
          ],
        Application: [
          {
            text: "",
            img: "/indoor/i14/2.jpg",
          },

          {
            text: "",
            img: "/indoor/i14/3.jpg"
          },
        
        
        ],
      
      },

      // 15
         {
        id: "RollerBlindsSolution",
        name: "Roller Blinds Solution",
        desc: "Motorized roller blinds are mainly applied for windows to shelter the  ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i15.jpg",
        imgs : "/indoor/i15/1.jpg",
 
       
        texts:[
         "Motorized roller blinds are mainly applied for windows to shelter the strong sunlight and cold air getting into room. it is drove by the AC or DC tubular motor, with the intelligent remote control systems, changing the manual operation to motorization. For some small size side by side window, with the joint components, one motor able to group drive multiple blinds up and down to achieve the most comfortable indoor light, and the most efficiency to reduce the error operation and project cost. In some smart buildings. it is connected with building master system for center and remote control."

            ],

       
        features : [
        "Drive by AC or DC motor;",
        "Low noise, precise mechanical limit position;",
        "Provide various motor types for different size of blinds;",
        "Put the rail at sides to fully keep the sunshine outside;",
        "For roof blinds or irregularity blinds using the guide rail or lead wires;",
        "Option of block out, sunshine fabrics etc."
          ],
        Application: [
           {
            text: "",
            img: "/indoor/i15/2.jpg"
          },
          {
            text: "",
            img: "/indoor/i15/3.jpg"
          },
        
        
        ],
      
      },

      //16
        {
        id: "MotorizedLift",
        name: "Motorized Lift Curtain Solution",
        desc: "Motorized lift curtain system is mainly applied to compound-floor",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i16.jpg",
        imgs : "/indoor/i16/3.png",
 
       
        texts:[
          "Motorized lift curtain system is mainly applied to compound-floor buildings with high built window, not easy to clean fabric and hand operation. Using the motorized curtain motor ,freely raise and lower the curtain by remote, more convenient. Motorized lift curtain system is composed of motorized roman blinds and motorized curtain. The motorized roman blinds are able to lift up and lower down the curtain system, and one system able to lift one to three curtain systems. lt is possible to make straight and curve system according to the building.",
        ],

       
        features : [
        " Easy to change and operate;",
        "Group connection via RS485 for center control;",
        "Both touch control and manual operate;",
        "Stop by block, Quiet design, limits auto setting;",
        "Suit to middle and high window;",
        "Applied to house,hotel,villa,meeting room etc;",
          ],
        Application: [
           {
            text: "",
            img: "/indoor/i16/2.jpg"
          },
         
        
        ],
      
      },

       // 17
        {
        id: "MotorizedCurtainSolutions",
        name: "Motorized Curtain Solutions",
        desc: "Motorized curtain is new generation product of manual fabric curtains, it",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/indoor/i17.jpg",
        imgs : "/indoor/i17/1.jpg",
 
       
        texts:[
          "Motorized curtain is a new generation product of manual fabric curtains, it is normally applied to large size Window, with exquisite craft and elegant appearance, it becomes the best fashionable choice for hotels, meeting rooms, business center and modern homes. A-OK motorized curtain system has powerful functions, including automatic limit setting, soft start and soft stop, speed adjustable etc. It has won a number of patents. It is not only a solution for sun shading, thermal insulation, glare or privacy, but also create a relax and confortable room to stay .",
        ],      
      },


  ],
  outdoor: [
    // outdoor solutions same structure mein

      //1
        {
        id: "GarageDoorController",
        name: "Garage Door Controller (Built In Lamp)- AC249-01",
        desc: "AC249-01 specialized in garage door, is an automatic and comprehensive",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o5.jpg",
        imgs:"/outdoor/o5/1.jpg",

        texts:[
          "AC249-01 specialized in garage door, is an automatic and comprehensive control system with built-in lamp, which not only can control the garage door by remoter to up/down and stop, but also has multiple protection functions, with these unique design, it can be applied in roller garage door, motorized door, faster roller door which have a high requirement for safety.",
        ],
        features : [
        " 433MHz or 868MHz, rolling code;",
        "Stop or stop and rebound when meet obstacle to avoid damage of objects;",
        "Auto set motor running time (1-90s);",
        "Auto set close door time (1-180s after the door fully opened);",
        "Over loading protection;",
        "Waterproof design, IP65 level, suitable for outdoor usage;",              
        "UV resistant and fire proof plastic housing;",
        "Specialized motor relay , work with motor power below 500W;",
        "Superheterodyne receive module, with sensibility -110dBm, operation distance 200m in the open air;",
        " SMT assembly, damp-proof surface;",
          ],

        Application: [
           {
            text: "Parameters",
       
            img: "/outdoor/o5/2.jpg"
          },
         

        
        ],
           
      },


      // 2
        {
        id: "DoubleChainWindowOpener",
        name: "Double Chain Window Opener",
        desc: "Electronic double-chain motor is widely used for motorized sliding   ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o2.jpg",
        imgs:"/outdoor/o2/1.jpg",

        texts:[
          "Electronic double-chain motor is widely used for motorized sliding sash, casement and skylight window etc, particular for high place where is hard to manual operation, works with different kinds of automation control systems like smoke detector and temperature detector, it would be easy to operate the windows open and close automatically.",
        ],
       
          features : [
       "Aluminum housing with sand blast treatment, fully reflect A-OK product texture and design style;",
       "The covers are zinc alloy die castings, and brackets are stainless steel 304;",
       "Stroke can be customized from 300-1000MM, the protection stops when the limit switch is triggered;",
       "Simple installation and disassembly, more easy-to-go design;",
       "Stop function in case of obstruction to protect the motor operation;",
      " Stop function in case of closing-obstruction to prevent the window can't close in place.",      
        
        ],
         Application: [
           {      
            img: "/outdoor/o2/2.jpg"
          },
         

        
        ],
        
           
      },

          //  3
        {
        id: "SynchronousLinearWindowOpener",
        name: "Synchronous Linear Window Opener",
        desc: "Linear motors are widely used for top-hung window, hopper window,",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o3.jpg",
        imgs:"/outdoor/o3/1.jpg",

        texts:[
          "Linear motors are widely used for top-hung window, hopper window, casement window, sash window and The roof skylight in airports, hotels, exhibition center, conference center, gym, opera house, science and technology museum, shopping center, greenhouse garden, industrial workshop, warehouse, other public places and villas, sunshine room, ordinary residential. After connecting with the fire control box, it can realize the fire linkage function, and connect with the intelligent controller to realize the intelligent control including timing and longrange opening or closing.",

        ],
       
      features : [
        "DC power supply;",
        "Stroke within 1M can be customized;",
        "Built-in overload protection;",
        "The outer tube is made of aviation aluminum;",
        "More than 10,000 durability tests;",
        "Precision planetary deceleration motor with low noise and high intensity;",
        "Can be connected to the fire control box to realize smoke and heat exhaust or intelligent ventilation;",
        "IP67 protection grade fearless of wind and rain;",
        
      ],
       Application: [
          {
            text:"AM46 DC Linear window opener",     
            img: "/outdoor/o3/2.jpg"
          },
          {
            text: "",
           img :"/outdoor/o3/3.jpg",
          }, 
          {
            text: "AM46 DC built-in synchronous Linear window opener",
            img :"/outdoor/o3/4.jpg",
          },
            {    
            img: "/outdoor/o3/5.jpg"
          },
          {
            text: "AM46 Electronic shutter linear window opener",
           img :"/outdoor/o3/6.jpg",
          }, 
          {
            text: "",
            img :"/outdoor/o3/7.jpg",
          },
            {
            text:"",
       
            img: "/outdoor/o3/8.jpg"
          },
          {
            text: "AM36 DC Linear window opener",
           img :"/outdoor/o3/9.jpg",
          }, 
          {
            text: "",
            img :"/outdoor/o3/10.jpg",
          },
            {
            text:"AM36 DC built-in synchronous linear window opener",
       
            img: "/outdoor/o3/11.jpg"
          },
          {
            text: "",
           img :"/outdoor/o3/12.jpg",
          }, 
          {
            text: "AM36 Electronic shutter linear window opener",
            img :"/outdoor/o3/13.jpg",
          },
          {
            img: "/outdoor/o3/14.jpg"
          },
          
        ],

           
      },

    // 4
    {
        id: "ManualCrankControlledMotor",
        name: "Manual Hand-Crank Controlled Motor",
        desc: "AM60 Standard Manual Operated Tubular Motor is mainly applied for ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o4.jpg",
        imgs:"/outdoor/o4/1.jpg",

        texts:[
          "AM60 Standard Manual Operated Tubular Motor is mainly applied for medium and small size of roller shutters, rolling doors, awnings and big size screens. It can be manually operated when electricity is off.",
        ],
        features : [
        " Quiet running, lower to 45db;",
        " Worm gear speed reducer makes it easier to move by hand;",
        " Repeat positioning accuracy is as low as 2 degrees;",
        " Double breaking design with patent;",
              
          ],

        Application: [
           {
            text: "",
       
            img: "/outdoor/o4/2.jpg"
          },
          {
            text: "AM45 Standard Tubular Motor",
            img :"/outdoor/o4/3.jpg",
          }, 
          {
            text :"Quite design, lower to 45dB " ,
            
            img :"/outdoor/o4/4.jpg",
          },
          {
            img :"/outdoor/o4/5.jpg",
          },
          
          

        
        ],
           
      },

      //5
       {
        id: "SmartSingleChainWindowOpener",
        name: "Smart Single Chain Window Opener",
        desc: "Electronic chain motor is widely used for motorized sliding sash, casement",
        description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o1.jpg",
        imgs:"/outdoor/o1/0.jpg",

        texts:[
          "Electronic chain motor is widely used for motorized sliding sash, casement and skylight window etc, particular for high place where is hard to manual operation, works with all kinds of remote control and realizes automation operation.",
        ],
        features : [
        "Aluminum housing with sand blast treatment, fully reflect A-OK product texture and design style;", 
        "The covers are zinc alloy die castings, and brackets are stainless steel 304;",
        " Stroke can be customized from 300-1000MM, the protection stops when the limit switch is triggered;",
        " Simple installation and disassembly, more easy-to-go design;",
        " Stop function in case of obstruction to protect the motor operation;",
        " Stop function in case of closing-obstruction to prevent the window can't close in place;",
        " RF built-in antenna, better rain sensing function;",
        " RF antenna and rain sensor combined design.",
       
          ],

        Application: [
           {
       
            img: "/outdoor/o1/1.jpg"
          },
          {
            text:"Wide voltage 100-240V AC power input, suitable for all country's different requests; Adjust the journey by adjusting knob; the Maximum stroke couldreach 400mm, The chain materials use double layers stainless metal, stable andsmooth during running ,Aluminum housing with sand blast treatment; the cover and bracketsare zinc alloy die castings. Double fireproof ABS internal casing, POM material track for chainmake motor silent and safe. Simple installation and disassembly, more easy-to-go design. Apply to small size window, down to 470mm windows, Stop on obstacle function, to protect the system and user safety . Precise electronic limit switch, overload and over current protection, Long service life, more than 10000 times open and close;",
            img :"/outdoor/o1/2.jpg",
          },
          {
            text: "Wide voltage 100-240V AC power input, suitable for all country's different requests .Adjust the journey by adjusting knob; the Maximum stroke couldreach 400mm .The chain materials use double layers stainless metal, stable andsmooth during running, Aluminum housing with sand blast treatment; the cover and bracketsare zinc alloy die castings Double fireproof ABS internal casing, POM material track for chainmake motor silent and safe.Simple installation and disassembly, more easy-to-go design Apply to small size window, down to 470mm windows, Stop on obstacle function, to protect the system and user safety Precise electronic limit switch, overload and over current protection. Long service life, more than 10000 times open and close;",
            img :"/outdoor/o1/3.jpg",
            
          }, 
        ],
        
           
      },



     
      //6
        {
        id: "4routesgroupcontroller",
        name: "4 Routes Group Controller (AC408-02)",
        desc: "Group controller works with mechanical manual switch and all ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o6.jpg",
       

        texts:[
        "Group controller works with mechanical manual switch and all A-OK radio receiver, to operate multi-unites motorization blinds at the same time.",     
         ],

       
          features : [
            "Fancy shape design,suitable for kinds of decoration style",
            "Fire-proof and anti-UV design, anti-aging",
            "Slid housing, ease and fast for installing；",
            "To achieve the single/group control for 4 motors easily；",
            " Available for RF and manual control；",
            "Photoelectric isolation dry contact middle control system, strong anti-jamming ability with long transmit distance；",
     
        ],
        Application: [
           {
            text: "Application Mode",
       
            img: "/outdoor/o6/1.jpg"
          },
          {    img: "/outdoor/o6/2.jpg"
          },
          {    img: "/outdoor/o6/3.jpg"
          },
        
        ],
           
      },

      // 7
       {
        id: "Wintergardencontroller",
        name: "Winter garden controller (Solar charging)",
        desc: "The integrated solution of outdoor sunshine room meets your primitive ",
        // description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o7.jpg",
        texts:[
          "The integrated solution of outdoor sunshine room meets your primitive desire to embrace nature at any time. 4 sunshade roller binds with personalized control of the top canopy, playing with sun and enjoying the natural pleasure when open, experiencing tranquility and keeping your private space when close. 200W AC fan and 1500W electric heater, cold an heat regulation, embracing the scenery without seasonal limit, decorating your garden with electrodeless dimming LED light band. IP65 grade, protecting your private territory without fear of wind and rain. Solar charging provides solutions for no power supply outdoor sunroom. It is not required to wire in advance and just to be installed at any times. Monocry stalline silicon solar panels have a high conversion rate and long service life. Prevention level IP65."
        ], 
        Application: [
          
          { img: "/outdoor/o7/1.jpg"},
        
        ],
           
      },

      //8
       {
        id: "MotorizedRollerShutterSolution",
        name: "Motorized Roller Shutter Solution",
        desc: "Motorized rolling curtain window has the advantages of beautiful and  ",
        description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o8.jpg",
        texts:[
          "Motorized rolling curtain window has the advantages of beautiful and simple appearance, firm and durable structure, suitable for office and family window shading, especially for large area glass curtain wall rolling curtain. When the shutter fabric is down, it can make the indoor light soft, free from direct sunlight, and achieve a good shading effect: when the shutter is up, its volume is very small, so that it can not be noticed. Rolling curtain fabric has half shading rolling curtain, half transparent rolling curtain, full shading rolling curtain series, can be determined according to the window position and use.",
        ], 
        Application: [
          
          { 
            text:"The system characteristics:",
            
          },
          { 
            text:"Energy saving and heat preservation: energy saving rolling Windows can play a role in blocking outdoor sunlight in summer, partition the temperature into the room, play the effect of heat insulation, shading. In winter can also play a role in ensuring indoor temperature and external convection, ensure indoor heating effect, all open will not produce any heat load, lighting, ventilation, ventilation. Excellent economic benefits, according to the annual household saving of air conditioning or heating equipment use power consumption, the cost can be recovered within 10 years;",
            
          }, 
          { 
            text:"EModern lifestyle: rolling Windows control the indoor light by opening and closing, to prevent the eyes from receiving light damage, and to prevent the fading of valuable homes in the house from sunlight exposure. Press the shutter remote control, free up and down movement, improve the quality of life;",
            
          },
           { 
            text:"Windproof, anti-theft: aluminum alloy material durable, especially suitable for coastal areas, long sunshine, strong ultraviolet light, high temperature, long summer, accompanied by typhoons of the city, the installation of rolling Windows, can be pillow without excellent",
            
          },  
          { 
            text:"Sound insulation: rolling Windows will reduce the invasion of outdoor noise, reduce noise pollution, improve the quality of life, and create a good rest space",
          },
          {
            text:"Blocking: The opening design of the curtain pieces can not only keep the indoor ventilation, but also prevent the dust and debris outside;",
            img: "/outdoor/o8/1.jpg"
            
          }
        ],
           
      },
      //9
       {
        id: "MotorizedAwningSolution",
        name: "Motorized Awning Solution",
        desc: "Awning, the use of motor to drive the rotation of aluminum alloy coil ",
        description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o9.jpg",
        texts:[
          "Awning, the use of motor to drive the rotation of aluminum alloy coil tube, so that the fabric wound in the coil tube up, down, at the same time by the arm support rod in the spring force of the fabric. The maximum opening Angle of the system is 0-130 degrees, which can be carried out by switch, force control, scenery control and other control methods.Has a comprehensive external sunshade function, can completely block ultraviolet radiation, reduce indoor temperature, reduce air conditioning load awning has energy saving effect, from the perspective of energy saving and environmental protection.It is of great significance: while blocking the hot summer, it can reflect the strong sunlight into the room in the form of diffuse light, so that the indoor light is bright but not blinding, and does not affect the landscape outside the window from the indoor, and extends people's living space from the indoor to the outdoor, creating a new living space: Its sunshade cloth has the special anti-ultraviolet function, not only makes the human skin from ultraviolet ray invasion, but also greatly extends the service life of interior decoration and furniture. "
        ], 
        Application: [
          
          { 
            text:"system features:",
            
          },
          { 
            text :"Sunshade basket series products unique shape. beautiful, more outstanding for its high strength, high durability, uv protection and temperature insulation effect, according to JIS standards in the safety of the effective consideration of snow resistance (bearing 875px snow). Strong wind resistance (42m/s strong wind);"
          }, 
          { 
           text : "High strength aluminum alloy material, the connection between the column and the top is reinforced with steel structure with built-in key words, which is more secure and firm. Aluminum alloy surface by powder electrostatic spraying treatment, oxidation resistance of up to 30 years;"           
          },
           { 
            text :"The use of high strength impact resistant poly broken acid material, strength is about 200 times of glass. Raw materials imported from Germany and processed in the country, through the double-sided co-extrusion process added cable outside material (UV) can effectively block more than 98% of the regular outside, protect the car surface paint, more effective temperature control continues to rise, but also has the effect of flame retardant, and can be in -30℃ to 60℃ (137℃ hot deformation is now.Like) ring filling under normal use for more than 30 years;"            
          },  
          { 
            text: "High strength silver alloy material, unique humanized design, avoid the top root water falling to the ground to cause second pollution to you. Reasonable structure and easy to clean, can facilitate the removal of dirt in the pipe. It is recommended that the width of a single piece should not be more than 3m and the height should not be more than 3m."
          },
          {
           
            img: "/outdoor/o9/1.jpg"
            
          }
        ],
           
      },

      //10
         {
        id: "MotorizedWingLOUVERSolution",
        name: " Motorized Wing LOUVER Solution",
        desc: "The basic functions include ventilation,shading and concealment,",
        description: "Motorized vertical curtain systems are widely used in high-rise glass curtain wall facades. The system uses a motor drive to achieve automatic control of the vertical curtain's opening and closing, as well as rotation. It is suitable for shading and heat insulation of large-area glass walls, effectively improving indoor environment comfort.",
        img: "/outdoor/o10.jpg",
        texts:[
          "The basic functions include ventilation, shading and concealment, and now the elements that used indoors are gradually moving outdoors and becoming an important element of the building facade. There is a sealed slot between the blade and the connecting piece, and a sealed ring and sealing strip between the blades to ensure that the louver can be isolated from external noise, dust, wind and rain when completely closed. The adjustable angle of the hundred blades can ensure the indoor natural ventilation, and at the same time can prevent outdoor harmful ultraviolet radiation: Automatic fire exhaust and ventilation combined, connected with the fire system, in emergency, can be automatically opened to achieve the effect of smoke exhaust ventilation.",
        ], 
        Application: [
          
          { 
            text:"The system characteristics",
            
          },
          { 
            text :"1.Lighting and shading :The sheet is slightly curved ,beautiful in shape and optional in color .Reduce the pressure of forward wind when closing , and the turning angle of the blade can be adjusted between 0 to 180 degree . The turning angle of the blade can be adjusted according to the angle of sun expose to achieve the best effect of shading and dimming.",
          }, 
          { 
           text : "2.Ventilation: strong protection, typhoon Nemesis blade is slightly curved, closed to reduce the pressure of the forward wind, not affected by wind (including typhoon), strong safety protection of building Windows, glass exterior walls."           
          },
           { 
            text :"3.Heat preservation, heat insulation, noise reduction: when the blades are closed, the sash is airtight, and the hundred blades are double hollow design, which can effectively maintain the indoor temperature and isolate the outdoor high temperature, and can reduce the noise of more than 30 db."            
          },  
          { 
            text: " 4.Fire control: can receive fire signals, such as smoke sensor, temperature sensor probe, fire emergency button, and receive the signal sent by the fire control center, as an automatic smoke exhaust cooling gate."
          },
          {
            text:"5.Occasion : factory smoke exhaust ventilation, civil sunshade anti-theft. Building exterior facade surfaces, typhoon protection Settings, improved ventilation Settings, school protection Settings, etc., can be achieved through different design or installation methods of ventilated shutter curtains.",
            img: "/outdoor/o10/1.jpg"
            
          }
        ],
           
      },

  ],
};

export default solutionData;
